<h2 mat-dialog-title class="mat-dialog-title--icons !flex items-center gap-2">
  <img class="google-icon" src="assets/img/icons/google-logo.svg" i18n-alt alt="Google logo" />
  <span i18n>Unlink Google Account</span>
</h2>
<form [formGroup]="newPasswordFormGroup">
  <mat-dialog-content class="dialog-content-scroll">
    <h3 i18n>Create a WISE password:</h3>
    <new-password-and-confirm [formGroup]="newPasswordFormGroup"></new-password-and-confirm>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close i18n>Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!newPasswordFormGroup.valid || isSaving"
      (click)="submit()"
      class="button--progress"
    >
      <ng-container i18n>Submit</ng-container>
      <mat-progress-bar mode="indeterminate" *ngIf="isSaving"></mat-progress-bar>
    </button>
  </mat-dialog-actions>
</form>
